import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ViewPdfMacroRendererProps } from '../src/ViewPdfMacroRenderer.tsx';

export const ViewPdfMacroHandler: LoadableType<ViewPdfMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPdfMacro" */ '../src/ViewPdfMacroRenderer.tsx'
			)
		).ViewPdfMacroRenderer,
});
